import { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { Tooltip } from "@mui/material";
import {
  Edit,
  Delete as DeleteIcon,
  Print,
  Visibility,
} from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { generatePdf } from "../../Sale/SalesOrderPrint";
pdfMake.vfs = pdfFonts.vfs;

export default function SalesOrderTable({data}) {
 

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

 
function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }
    
  return (
    <>
        <TableContainer component={Paper} sx={{
            maxHeight: '48vh', // 👈 yaha height do
            overflow: "auto",
          }}>
          <Table
            hover
            stickyHeader
            size="small"
            sx={{
              minWidth: "max-content",
              "& td, & th": {
                borderBottom: "1px solid #ccc",
                whiteSpace: "nowrap",
              },
            }}
          >
            <TableHead
              sx={{
                "& th": {
                  fontWeight: "bold",
                  color: (theme) =>
                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                },
              }}
            >
              <TableRow
                sx={{
                  backgroundColor: "#f5f5f5",
                  "& th": {
                    fontWeight: "bold",
                    color: "#333",
                    borderBottom: "1px solid #999",
                    whiteSpace: "nowrap",
                  },
                }}
              >
              
                <TableCell align="center">S.No.</TableCell>

                <TableCell
                  sx={{
                    position: "sticky",
                    left: 0,
                    minWidth: 100,
                    backgroundColor: "#fff",
                    zIndex: 3,
                  }}
                  align="center"
                >
                  So. No.
                </TableCell>
        

                <TableCell align="center">Project</TableCell>
                <TableCell align="center">Grand Total</TableCell>
                <TableCell align="center">Ad Rec</TableCell>
                <TableCell align="center">Bal Amt</TableCell>
                <TableCell align="center">PO No</TableCell>
                <TableCell align="center">PO Date</TableCell>
                <TableCell align="center">Debtor</TableCell>

                {/* <TableCell align="center">Approved By</TableCell> */}
                <TableCell align="center">Date</TableCell>
                {/* <TableCell align="center">Remarks</TableCell> */}
                <TableCell
                  sx={{
                    position: "sticky",
                    right: 0,
                    minWidth: 140,
                    backgroundColor: "#fff",
                    zIndex: 3,
                  }}
                  align="center"
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <ToastContainer />
            <TableBody>
              {data.map((order, idx) => {
                const defaultBg = idx % 2 === 0 ? "#fafafa" : "#ffffff";
                const hoverBg = "#e3f2fd ";
                return (
                  <TableRow
                    hover
                    key={idx}
                    sx={{
                      backgroundColor: defaultBg,
                      "&:hover": {
                        backgroundColor: hoverBg,
                        "& td": {
                          backgroundColor: hoverBg, // 👈 sticky cells bhi hover color lenge
                        },
                      },
                      "& td": {
                        paddingTop: "2px !important",
                        paddingBottom: "2px !important",
                        fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
               

                    <TableCell align="center">{idx + 1}</TableCell>

                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        minWidth: 100,
                        backgroundColor: defaultBg,
                        zIndex: 2,
                      }}
                      align="center"
                    >
                      {order.so_no}
                    </TableCell>
                  
                    <TableCell align="center">
                      {order.project_name || "-"}
                    </TableCell>
                    <TableCell align="center">
                      {order.grand_total
                        ? Number(order.grand_total).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          })
                        : "0.00"}
                    </TableCell>
                    <TableCell align="center">
                      {order.rec_amount
                        ? Number(order.rec_amount).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          })
                        : "0.00"}
                    </TableCell>
                    <TableCell align="center">
                      {(Number(order.grand_total)-Number(order.rec_amount)).toFixed(1)}
                     
                    </TableCell>
                    <TableCell align="center">{order.po_number}</TableCell>
                    <TableCell align="center">
                      {new Date(order.order_date).toLocaleDateString("en-GB")}
                    </TableCell>
                    <TableCell align="center">
                      {order.party_details?.company_name}
                    </TableCell>

                    {/* <TableCell align="center">{order.approved_name}</TableCell> */}
                    <TableCell align="center">
                      {formatOnlyDate(order.created_at)}
                    </TableCell>
                    {/* <TableCell align="center">
                      <Tooltip title={order.remarks} arrow>
                        <span>{truncateText(order.remarks, 20)}</span>
                      </Tooltip>
                    </TableCell> */}
                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        minWidth: 140,
                        backgroundColor: defaultBg,
                        zIndex: 2,
                      }}
                      align="center"
                    >
                      <span style={{ display: "inline-block", width: 40 }}>
                        {order.project ? (
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            size="small"
                            color="info"
                            onClick={() =>
                              window.open(`${order.project}`, "_blank")
                            }
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                        ) : (
                          <span
                            style={{ display: "inline-block", width: 40 }}
                          />
                        )}
                      </span>
                   
                   
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        size="small"
                        color="default"
                        onClick={() => generatePdf(order)}
                      >
                        <Print fontSize="small" />
                      </IconButton>
                     
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
     
    </>
  );
}
